import { apiUrl, apiUrl2 } from '../../../settings'

export const AddHeadTypeUrl = () => {
  return `${apiUrl2}/addHeadCategory`;
};
export const headTypeListUrl = () => {
  return `${apiUrl2}/headCategoryList`;
};
export const getAllHeadCategoryUrl = () => {
  return `${apiUrl2}/getAllHeadCategory`;
};

export const AddUniversityHeadUrl = () => {
  return `${apiUrl2}/addUniversityHead`;
};
export const getUniversityListUrl = () => {
  return `${apiUrl2}/getUniversityHeadList`;
};
export const getAllUniversityHeadUrl = () => {
  return `${apiUrl2}/getUniversityHeadList`;
};
export const updateUniversityHeadUrl = () => {
  return `${apiUrl}/application/updateUniHead`;
};